export default __webpack_public_path__ + "static/IMG_1259-c3dd1ed65d15b6c51ebfd77b0f0a15bf.jpg";